export const CATEGORY_SORT = [
    {
        value: 'desc',
        option: 'weighted',
        name: 'Most Relevant',
    },
    {
        value: 'desc',
        option: 'bestsellers',
        name: 'Most Popular',
    },
    {
        value: 'asc',
        option: 'name',
        name: 'Name',
    },
    {
        value: 'asc',
        option: 'price',
        name: 'Lowest Price',
    },
    {
        value: 'desc',
        option: 'price',
        name: 'Highest Price',
    },
];
